export default __webpack_public_path__ + "static/media/complete-sphere.2ab3809e.wav";